<template>
  <div>
    <GenerateForm :form="form" :data="data" :save-action="updateUserData" />
  </div>
</template>

<script>

import { reactive } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

import { updateUser } from '@/mixins/requests';
import { countryOptions, isInImpersonateModeNotification } from '@/mixins/utils';

import GenerateForm from '@/components/common/GenerateForm';

export default {
  components: { GenerateForm },
  setup () {
    const store = useStore();
    const router = useRouter();

    const data = reactive({ ...store.state.user });

    const form = reactive([
      [
        { reference: 'TITLE', id: 'gender', type: 'select', class: 'col-12', required: true, options: [{ value: 'mr', text: 'M.' }, { value: 'mme', text: 'Mme' }], rules: ['required', 'option'] }
      ],
      [
        { reference: 'FIRST_NAME', id: 'firstname', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'YOUR_FIRST_NAME' },
        { reference: 'LAST_NAME', id: 'lastname', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'YOUR_LAST_NAME' }
      ],
      [
        { reference: 'BIRTH_DATE', id: 'birth_date', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'Ex: 27/03/1980', mask: '##/##/####' },
        { reference: 'NATIONALITY', id: 'nationality', type: 'select', class: 'col-12 sm-col-6', placeholder: 'Votre nationalité', required: true, options: countryOptions, disabled: false }
      ],
      [
        { reference: 'PHONE_NUMBER', id: 'mobilephone', type: 'tel', class: 'col-12 sm-col-6', required: true, placeholder: 'MOBILE_PLACEHOLDER' }
      ],
      [
        { reference: 'ADDRESS_1', id: 'street_number', type: 'text', class: 'col-12 sm-col-6', required: false, placeholder: '', disabled: false },
        { reference: 'ADDRESS_2', id: 'street_name', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: '', disabled: false }
      ],
      [
        { reference: 'ADDRESS_COMPLEMENT', id: 'address2', type: 'text', class: 'col-12 sm-col-6', required: false, placeholder: '' },
        { reference: 'ZIP_CODE', id: 'zip_code', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: '', disabled: false }
      ],
      [
        { reference: 'CITY', id: 'town', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: '', disabled: false },
        { reference: 'COUNTRY', id: 'country', type: 'select', class: 'col-12 sm-col-6', placeholder: 'Votre pays de résidence', required: true, options: countryOptions, disabled: false }
      ]
    ]);

    async function updateUserData () {
      if (isInImpersonateModeNotification()) {
        return;
      }

      store.commit('setLoading', true);
      const user = await updateUser(data);

      if (user) {
        router.replace({ name: 'MyProfile' });
      }

      store.commit('setLoading', false);
    }

    return { data, form, updateUserData };
  }
};
</script>

<style>
.input-height {
  height: 50px;
}

</style>
